import React from 'react';
import { Skeleton, Card, CardContent, Box, CardActions } from '@mui/material';

const PostSkeleton = () => {
  return (
    <Card>
      <Skeleton variant="rectangular" height={200} />
      <CardContent>
        <Box display="flex" alignItems="center" mb={2}>
          <Skeleton variant="circular" width={40} height={40} />
          <Box ml={2} width="100%">
            <Skeleton width="60%" />
            <Skeleton width="40%" />
          </Box>
        </Box>
        <Skeleton width="80%" height={30} />
        <Skeleton width="100%" />
        <Skeleton width="100%" />
        <Skeleton width="60%" />
      </CardContent>
      <CardActions>
        <Box display="flex" justifyContent="space-between" width="100%">
          <Skeleton width="40%" height={30} />
          <Box>
            <Skeleton variant="circular" width={30} height={30} />
            <Skeleton variant="circular" width={30} height={30} sx={{ ml: 1 }} />
          </Box>
        </Box>
      </CardActions>
    </Card>
  );
};

export default PostSkeleton;